var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuthSprites(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150,
    height: 100,
    viewBox: "0 0 150 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "person-svgrepo-com",
    transform: "translate(-45 -25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M160.063,33.454a4.644,4.644,0,0,0-8.05,3.6c.2,2.729,2.275,4.948,4.629,4.948s4.427-2.219,4.628-4.947a4.711,4.711,0,0,0-1.207-3.6Z",
    transform: "translate(-99.362)",
    fill: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M65.137,296.571H49.423a1.384,1.384,0,0,1-1.08-.5,1.576,1.576,0,0,1-.321-1.3,7.643,7.643,0,0,1,3.4-5.079,10.959,10.959,0,0,1,11.714,0,7.642,7.642,0,0,1,3.4,5.078,1.576,1.576,0,0,1-.321,1.3A1.384,1.384,0,0,1,65.137,296.571Z",
    transform: "translate(0 -244.572)",
    fill: "#d1d1d1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_348_",
    transform: "translate(3 5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_350_",
    d: "M10.538,69.541a.909.909,0,0,1-1.075,0L1.818,63.935,0,62.6V75.475a.909.909,0,0,0,.909.909H19.091A.909.909,0,0,0,20,75.475V62.6l-1.818,1.333Z",
    transform: "translate(0 -21.232)",
    fill: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_351_",
    d: "M28.7,46.448,37.5,40H19.911Z",
    transform: "translate(-18.704)",
    fill: "#d1d1d1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "lock-svgrepo-com",
    transform: "translate(-75 75)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 8.378,
    cy: 8.378,
    r: 8.378,
    transform: "translate(77.5 8.245)",
    fill: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M134.1,7.423V5.452a3.857,3.857,0,0,1,7.713,0V7.423l.026.011a9.942,9.942,0,0,1,1.57.836V5.452a5.452,5.452,0,1,0-10.9,0V8.27a9.956,9.956,0,0,1,1.57-.836Z",
    transform: "translate(-52.074)",
    fill: "#d1d1d1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthSprites);
export default __webpack_public_path__ + "static/media/auth-sprites.db7b43d4e05019b346e8db919afc2a39.svg";
export { ForwardRef as ReactComponent };